'use client';

import {
  Search,
  Globe,
  GraduationCap,
  BookOpen,
  ShieldCheck,
  Lock,
  FileText,
  SpellCheck,
} from 'lucide-react';

import styles from './onlineService.style.scss';

const services = [
  {
    title: 'Library OPAC',
    description: 'Search and reserve library collections online',
    icon: Search,
    link: 'https://opac.juniv.edu/',
  },
  {
    title: 'Library Website',
    description:
      'Library Service portal for resources, subscriptions & Services',
    icon: Globe,
    link: 'https://library.juniv.edu/',
  },
  {
    title: 'Academic Repository',
    description:
      'Services for dissemination of digital materials created by the University and its community',
    icon: GraduationCap,
    link: 'https://repository.juniv.edu/',
  },
  {
    title: 'e-Resources',
    description:
      'e-book & e-journal subscription for Faculty and Students',
    icon: BookOpen,
    link: 'https://library.juniv.edu/a-z-database',
  },
  {
    title: 'Plagiarism Service',
    description:
      'iThenticate — advanced plagiarism detection for academic integrity',
    icon: ShieldCheck,
    link: 'https://jahangirnagaruniversity.turnitin.com/',
  },
  {
    title: 'Remote Access',
    description:
      'e-Resource browsing from outside of the campus',
    icon: Lock,
    link: 'https://my.openathens.net/?passiveLogin=false',
  },
  {
    title: 'EndNote',
    description:
      'Reference management and citation tool for researchers',
    icon: FileText,
    link: 'https://endnote.com/',
  },
  {
    title: 'Grammarly',
    description:
      'AI-powered writing assistance and grammar checking',
    icon: SpellCheck,
    link: 'https://www.grammarly.com',
  },
];

export default function OnlineServices() {
  return (
    <section className="section">
      <div className="inner">
        <div className="header">
          <span className="eyebrow">Digital Infrastructure</span>
          <h2 className="title">Online Services</h2>
          <p className="subtitle">
            Access the full suite of library resources — anytime, from anywhere.
          </p>
        </div>

        <div className="grid">
          {services.map((service) => {
            const Icon = service.icon;

            return (
              <a
                key={service.title}
                href={service.link}
                target="_blank"
                rel="noopener noreferrer"
                className="card"
              >
                <div className="cardTop">
                  <span className="icon">
                    <Icon size={28} strokeWidth={1.8} />
                  </span>
                </div>

                <h3 className="cardTitle">{service.title}</h3>
                <p className="cardDesc">{service.description}</p>

                <div className="cardLine" />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}